module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.options.length) ? _c('div', {
    staticClass: "select-container flex col",
    on: {
      "mouseenter": function($event) {
        return _vm.toggleOptions(true)
      }
    }
  }, [_c('div', {
    staticClass: "select flex"
  }, [_c('span', [_vm._v(" " + _vm._s(_vm.value))]), _vm._v(" "), _c('img', {
    staticClass: "icon",
    attrs: {
      "src": _vm.svgDown,
      "alt": "down"
    }
  })]), _vm._v(" "), _c('ul', {
    class: {
      'options-container': true,
      none: !_vm.showOptions
    },
    on: {
      "mouseleave": function($event) {
        return _vm.toggleOptions(false)
      }
    }
  }, [_vm._l((_vm.options), function(option) {
    return _c('li', {
      key: option,
      class: {
        option: true,
        selected: option === _vm.value
      },
      on: {
        "click": function($event) {
          return _vm.setOption(option, _vm.side)
        }
      }
    }, [_vm._v("\n      " + _vm._s(option) + "\n    ")])
  }), _vm._v(" "), _c('li', {
    staticClass: "option down",
    on: {
      "click": function($event) {
        return _vm.toggleOptions(false)
      }
    }
  }, [_c('img', {
    staticClass: "icon",
    attrs: {
      "src": _vm.svgUp,
      "alt": "up"
    }
  })])], 2)]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4f0fb124","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dictionary/choose.vue
// module id = 379
// module chunks = 0 5